__turbopack_context__.v({
  "backLink": "contact-module__xwJ-uq__backLink",
  "btnReset": "contact-module__xwJ-uq__btnReset",
  "btnSpinner": "contact-module__xwJ-uq__btnSpinner",
  "btnSubmit": "contact-module__xwJ-uq__btnSubmit",
  "card": "contact-module__xwJ-uq__card",
  "errorBanner": "contact-module__xwJ-uq__errorBanner",
  "fieldError": "contact-module__xwJ-uq__fieldError",
  "fieldGroup": "contact-module__xwJ-uq__fieldGroup",
  "footerLink": "contact-module__xwJ-uq__footerLink",
  "formTitle": "contact-module__xwJ-uq__formTitle",
  "infoIcon": "contact-module__xwJ-uq__infoIcon",
  "infoItem": "contact-module__xwJ-uq__infoItem",
  "infoItems": "contact-module__xwJ-uq__infoItems",
  "infoLabel": "contact-module__xwJ-uq__infoLabel",
  "infoPanel": "contact-module__xwJ-uq__infoPanel",
  "infoText": "contact-module__xwJ-uq__infoText",
  "infoTitle": "contact-module__xwJ-uq__infoTitle",
  "infoValue": "contact-module__xwJ-uq__infoValue",
  "input": "contact-module__xwJ-uq__input",
  "inputError": "contact-module__xwJ-uq__inputError",
  "label": "contact-module__xwJ-uq__label",
  "layout": "contact-module__xwJ-uq__layout",
  "logoLink": "contact-module__xwJ-uq__logoLink",
  "page": "contact-module__xwJ-uq__page",
  "pageFooter": "contact-module__xwJ-uq__pageFooter",
  "recaptchaNote": "contact-module__xwJ-uq__recaptchaNote",
  "recaptchaWrap": "contact-module__xwJ-uq__recaptchaWrap",
  "row": "contact-module__xwJ-uq__row",
  "spin": "contact-module__xwJ-uq__spin",
  "successIcon": "contact-module__xwJ-uq__successIcon",
  "successState": "contact-module__xwJ-uq__successState",
  "successText": "contact-module__xwJ-uq__successText",
  "successTitle": "contact-module__xwJ-uq__successTitle",
  "textarea": "contact-module__xwJ-uq__textarea",
  "topBar": "contact-module__xwJ-uq__topBar",
});
